import script from "./AppLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppLayout.vue?vue&type=script&setup=true&lang=ts"

import "./AppLayout.vue?vue&type=style&index=0&id=2e68c946&lang=css"

const __exports__ = script;

export default __exports__